import { createContext, useContext } from "react";
import { useTheme } from "@/shared/hooks/useTheme";
import { ThemeContextProps } from "@/shared/types/themes";

const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);

export const ThemeProvider = ({ children }: React.PropsWithChildren) => {
  const theme = useTheme();

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeContext = (): ThemeContextProps => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("Une erreur est survenue lors de la récupération du thème.");
  }
  return context;
};
